import { render, staticRenderFns } from "./ComplaintFormView.vue?vue&type=template&id=08e9fac4&scoped=true&lang=pug&"
import script from "./ComplaintFormView.vue?vue&type=script&lang=ts&"
export * from "./ComplaintFormView.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintFormView.vue?vue&type=style&index=0&id=08e9fac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e9fac4",
  null
  
)

export default component.exports